import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  const footerLinks = {
    Podcast: [
      { name: 'Episodes', href: '/episodes' },
      { name: 'Blog', href: '/blog' },
      { name: 'About', href: '/about' },
      { name: 'Guests', href: '/guests' },
    ],
    Connect: [
      { name: 'Subscribe', href: '/subscribe' },
      { name: 'Contact', href: '/contact' },
      { name: 'RSS Feed', href: '/feed.xml', external: true },
    ],
    Social: [
      { name: 'Twitter', href: 'https://twitter.com/promptedthoughts', external: true },
      { name: 'LinkedIn', href: 'https://linkedin.com/company/promptedthoughts', external: true },
      { name: 'YouTube', href: 'https://youtube.com/@promptedthoughts', external: true },
    ],
  }

  return (
    <footer className="bg-charcoal border-t border-slate mt-auto">
      <div className="container-custom py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand section */}
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center space-x-2 mb-4 group">
              <div className="w-8 h-8 bg-gradient-to-br from-cyan to-purple rounded-full flex items-center justify-center">
                <span className="text-charcoal font-mono font-bold">&gt;_</span>
              </div>
              <span className="text-lg font-bold text-off-white">Prompted Thoughts</span>
            </Link>
            <p className="text-sm text-gray-400 mb-4">
              Where prompts meet production: AI • Apps • DX • Data
            </p>
            <p className="text-xs text-gray-500">
              Developer-centric conversations at the intersection of Generative AI and software
              engineering.
            </p>
          </div>

          {/* Links sections */}
          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h3 className="text-sm font-semibold text-off-white mb-4">{category}</h3>
              <ul className="space-y-2">
                {links.map((link) =>
                  link.external ? (
                    <li key={link.name}>
                      <a
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm text-gray-400 hover:text-cyan transition-colors gradient-underline"
                      >
                        {link.name}
                      </a>
                    </li>
                  ) : (
                    <li key={link.name}>
                      <Link
                        to={link.href}
                        className="text-sm text-gray-400 hover:text-cyan transition-colors gradient-underline"
                      >
                        {link.name}
                      </Link>
                    </li>
                  )
                )}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom section */}
        <div className="mt-12 pt-8 border-t border-slate flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
          <p className="text-xs text-gray-500">
            &copy; {currentYear} Prompted Thoughts. All rights reserved.
          </p>
          <div className="flex items-center space-x-4">
            <a
              href="/feed.xml"
              className="text-xs text-gray-500 hover:text-cyan transition-colors"
              aria-label="RSS Feed"
            >
              RSS
            </a>
            <span className="text-gray-600">•</span>
            <Link
              to="/about"
              className="text-xs text-gray-500 hover:text-cyan transition-colors"
            >
              About
            </Link>
            <span className="text-gray-600">•</span>
            <Link
              to="/contact"
              className="text-xs text-gray-500 hover:text-cyan transition-colors"
            >
              Contact
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
